import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['overlay'];

  connect () {
    this.show = this.show.bind(this);
    this.hideOnSubmitEnd = this.hideOnSubmitEnd.bind(this);
    this.hide = this.hide.bind(this);

    this.element.addEventListener('turbo:submit-start', this.show);
    this.element.addEventListener('turbo:submit-end', this.hideOnSubmitEnd);
    document.addEventListener('turbo:before-cache', this.hide);
  }

  disconnect () {
    this.element.removeEventListener('turbo:submit-start', this.show);
    this.element.removeEventListener('turbo:submit-end', this.hideOnSubmitEnd);
    document.removeEventListener('turbo:before-cache', this.hide);
    this.unlockScroll();
  }

  show () {
    if (!this.hasOverlayTarget) return;

    this.overlayTarget.hidden = false;
    this.lockScroll();
  }

  hideOnSubmitEnd (event) {
    if (event.detail.success) return;

    this.hide();
  }

  hide () {
    if (!this.hasOverlayTarget) return;

    this.overlayTarget.hidden = true;
    this.unlockScroll();
  }

  lockScroll () {
    document.body.style.overflow = 'hidden';
  }

  unlockScroll () {
    document.body.style.overflow = '';
  }
}
